import { MuscleGroup } from '../../types'
import { MUSCLE_GROUP_COLORS, MUSCLE_GROUP_DISPLAY_NAMES } from '../../utils'

interface CompactVolumeCardProps {
  muscleGroup: MuscleGroup
  sets: number
  maxVolume?: number
}

export const CompactVolumeCard = ({ muscleGroup, sets, maxVolume = 1 }: CompactVolumeCardProps) => {
  const hasVolume = sets > 0
  const muscleGroupColor = MUSCLE_GROUP_COLORS[muscleGroup]

  // Calculate fill percentage (0-100) based on sets relative to maxVolume
  const fillPercentage = maxVolume > 0 ? (sets / maxVolume) * 100 : 0

  return (
    <div
      className={`bg-card relative flex aspect-square flex-col items-center justify-center overflow-hidden rounded-lg border p-3 transition-all duration-200 ${hasVolume ? 'border-border' : 'border-border/40 opacity-60'} `}
      style={{
        borderColor: hasVolume ? `${muscleGroupColor}20` : undefined
      }}
    >
      {/* Background fill that grows from bottom to top */}
      {hasVolume && (
        <div
          className="absolute inset-0 transition-all duration-500 ease-out"
          style={{
            background: `${muscleGroupColor}10`,
            transform: `translateY(${100 - fillPercentage}%)`
          }}
        />
      )}
      {/* Content - positioned above the background fill */}
      <div className="relative z-10 flex flex-col items-center justify-center">
        {/* Color dot */}
        <div
          className={`mb-2 h-2.5 w-2.5 rounded-full ${hasVolume ? '' : 'opacity-50'}`}
          style={{ backgroundColor: muscleGroupColor }}
        />

        {/* Muscle group name */}
        <div className="text-center">
          <p className="text-xs leading-tight font-medium">
            {MUSCLE_GROUP_DISPLAY_NAMES[muscleGroup]}
          </p>

          {/* Sets count */}
          <div className="mt-1 flex flex-col items-center">
            <span className={`text-lg font-bold ${hasVolume ? '' : 'text-muted-foreground'}`}>
              {sets}
            </span>
            <span className="text-muted-foreground text-xs">sets</span>
          </div>
        </div>
      </div>
    </div>
  )
}
